export default __webpack_public_path__ + "static/media/gallery14.8af81f25.jpg";